export default "__VITE_ASSET__DcVzwgEb__"